<template>
  <div id="menu-full" class="menu-full">
    <v-container class="no-max-width">
      <div class="view-side">
        <img v-if="sideBackgroundSrc" :src="sideBackgroundSrc" />

        <div class="view-side-top">
          <v-icon @click="startOver"> mdi-home </v-icon>
        </div>

        <div id="view-side-body" class="view-side-body">
          <div v-if="classifies && classifies.length > 0" class="d-flex">
            <div
              v-for="(c, index) in classifies"
              :key="index"
              @click="classifyClicked(c)"
              :class="[c.name == classifyName ? 'classify-selected' : 'classify']"
            >
              {{ c.getText() }}
            </div>
            <v-icon
              v-if="categoryID > 0 && news && news.length > 0"
              @click="category = undefined"
              class="classify ml-auto mr-2"
              style="font-size: 1.2em;"
              >mdi-newspaper-variant-outline</v-icon
            >
          </div>
          <v-list class="cat-list">
            <v-list-item
              :class="{ 'cat-item-selected': category && category.key == cat.key }"
              v-for="(cat, index) in categories"
              :key="index"
              @click="catClicked(cat)"
            >
              <div class="cat-item-body">
                {{ cat.getText() }}
                <!--
                <div v-if="cat.ID == -2 && $store.getters.pointRedeemEnabled" class="redeem-item">
                  {{ $t("redeem") }}
                </div>
                <div v-else-if="cat.ID == -1" class="favorite-item">
                  ！
                  {{ $t("favorite") }}
                </div>
                <div v-else>
                  <div v-if="$store.state.descrIndex == 0">
                    {{ cat.descr }}
                  </div>
                  <div v-if="$store.state.descrIndex == 1">
                    {{ cat.descr1 }}
                  </div>
                  <div v-if="$store.state.descrIndex == 2">
                    {{ cat.descr2 }}
                  </div>
                </div>
                -->

                <div v-if="catOrderQty(cat) > 0" class="ordered-qty">
                  {{ catOrderQty(cat) }}
                </div>
              </div>
            </v-list-item>
          </v-list>
        </div>
        <PoweredBy></PoweredBy>
      </div>

      <div id="view-body" :class="['view-body']">
        <PageHeader></PageHeader>

        <div id="view-body-body" class="view-body-body">
          <div v-if="categoryID == 0" class="adv-view">
            <img v-for="(n, index) in news" :key="index" :src="n.downloadPath" />
          </div>

          <template v-else>
            <div v-if="classify && classify.view == 'list'" class="list-view">
              <img v-if="cachedBackgroundSrc" :src="cachedBackgroundSrc" class="background-image" />
              <div class="list-view-container" id="list-view-container">
                <MenuCatList
                  v-for="(cat, index) in categories"
                  :key="index"
                  :cat="cat"
                  :showCatName="true"
                  @itemClicked="itemClicked"
                ></MenuCatList>
              </div>
            </div>
            <div v-else-if="classify && classify.view == 'grid'" class="grid-view">
              <img v-if="cachedBackgroundSrc" :src="cachedBackgroundSrc" class="background-image" />
              <div class="grid-view-container" id="grid-view-container">
                <MenuCatGrid
                  v-for="(cat, index) in categories"
                  :key="index"
                  :cat="cat"
                  :showCatName="true"
                  @itemClicked="itemClicked"
                ></MenuCatGrid>
              </div>
            </div>
            <div v-else>
              <div v-for="(cat, index) in categories" :key="index">
                <div v-if="cat.key == categoryKey">
                  <div
                    v-if="cat.menuSchema && cat.menuSchema.view == 'image'"
                    :class="['image-view', 'scroll-' + cat.menuSchema.imageOverflow]"
                  >
                    <img
                      v-if="cachedBackgroundSrc"
                      :src="cachedBackgroundSrc"
                      :usemap="`#map-${cat.key}`"
                      @load="itemBackgroundLoaded(cat)"
                    />

                    <div v-if="cat.items">
                      <div v-for="(item, index) in cat.items" :key="index">
                        <div
                          v-show="$store.getters.orderItemQtyTotal(item) > 0 && item.menuSchema.quantityBadgeCoords"
                          class="badge-ordered-qty"
                          :style="qtyBadgeStyle(item)"
                        >
                          {{ $store.getters.orderItemQtyTotal(item) }}

                          <div
                            v-if="item.itemDialog === false || item.options.length == 0"
                            class="qty-adj-button"
                            @click.stop="itemClicked({ item: item, orderQty: -1 })"
                          >
                            <v-icon class="order-qty-button">
                              mdi-minus
                            </v-icon>
                          </div>
                        </div>
                      </div>
                    </div>

                    <map v-if="cat.items" :name="`map-${cat.key}`">
                      <area
                        v-for="(item, index) in cat.items"
                        :key="index"
                        :coords="item.menuSchema.coords"
                        @click="itemClicked({ item: item, orderQty: 1 })"
                      />
                    </map>

                    <!--
                    <div>
                      <div style="border:solid 2px red; position: absolute; top:0px; left:0px; width: 100px; height: 100px"></div>
                    </div>
                    -->

                  </div>

                  <div v-else-if="cat.menuSchema && cat.menuSchema.view == 'list'" class="list-view">
                    <img v-if="cachedBackgroundSrc" :src="cachedBackgroundSrc" class="background-image" />
                    <MenuCatList :cat="cat" @itemClicked="itemClicked"></MenuCatList>
                  </div>

                  <div v-else class="grid-view">
                    <img v-if="cachedBackgroundSrc" :src="cachedBackgroundSrc" class="background-image" />
                    <MenuCatGrid :cat="cat" @itemClicked="itemClicked"></MenuCatGrid>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div v-if="menuMessage.text" class="view-body-body-bottom" :style="menuMessage.style">
            <div v-html="menuMessage.text"></div>
          </div>
        </div>
      </div>
    </v-container>

    <div class="cart" v-if="$store.getters.padSetting.menuMode !== true">
      <div class="cart-badge">
        <div class="cart-qty" v-if="$store.getters.orderItemQtyTotal() > 0">
          {{ $store.getters.orderItemQtyTotal() }}
        </div>
        <v-icon @click="checkOutClicked">mdi-cart</v-icon>
      </div>
    </div>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <CartDialog ref="cartDialog"></CartDialog>
    <DebugDialog ref="debugDialog"></DebugDialog>
    <InputDialog password ref="inputDialog"></InputDialog>
    <OrderDialog ref="orderDialog" @updateOrderQty="updateOrderQty"></OrderDialog>
    <TimeUpDialog ref="timeUpDialog" @home="home"></TimeUpDialog>
  </div>
</template>

<script>
import PoweredBy from "@/components/PoweredBy";
import PageHeader from "@/components/PageHeader.vue";
import MenuCatGrid from "@/components/MenuCatGrid.vue";
import MenuCatList from "@/components/MenuCatList.vue";

import CartDialog from "@/dialogs/CartDialog";
import DebugDialog from "@/dialogs/DebugDialog";
import OrderDialog from "@/dialogs/OrderDialog";
import InputDialog from "@/dialogs/InputDialog";
import TimeUpDialog from "@/dialogs/TimeUpDialog";

import mAnalytics from "@/modules/analytics";
import mApp from "@/modules/app";
import mDialog from "@/modules/dialog";
import mOrder from "@/modules/order";
import mUtils from "@/modules/utils";

import { Howl } from "howler";
import bell from "@/assets/audio/bell.mp3";

//import imageMapResize from 'image-map-resizer'

//const wait = (n) => new Promise((resolve) => setTimeout(resolve, n));

export default {
  components: {
    PoweredBy,
    PageHeader,
    MenuCatGrid,
    MenuCatList,

    CartDialog,
    DebugDialog,
    InputDialog,
    OrderDialog,
    TimeUpDialog,
  },

  data() {
    return {
      mUtils: mUtils,

      defaultLogo: false,

      refreshing: false,

      category: undefined,
      classifyName: undefined,

      viewScrollEventDisabled: false,

      notificationSound: undefined,

      cachedBackgroundSrc: null, // cached blob URL for the background image
    };
  },

  created() {
    // Non-reactive cache for blob URLs, keyed by original image src
    this._imageCache = {};
    this._bgImageGen = 0; // generation counter to discard stale preloads
  },

  async activated() {
    console.log("menu-full activated", this.$route.params);

    this.viewScrollEventDisabled = false;

    if (this.$store.state.routeFrom.name == "Home") {
      if (this.classifies && this.classifies.length > 0) this.classifyName = this.classifies[0].name;
      else this.classifyName = undefined;

      if (this.news && this.news.length > 0) {
        this.category = undefined;
      } else {
        if (this.classify && this.classify.categories && this.classify.categories.length > 0) {
          this.category = this.classify.categories[0];
        }
      }

      this.$store.dispatch("PAD_GET_NUM_OF_GUESTS");
    }
  },

  deactivated() {
    if (this.notificationSound) this.notificationSound.stop();

    // Revoke cached blob URLs to free memory
    for (const key of Object.keys(this._imageCache)) {
      URL.revokeObjectURL(this._imageCache[key]);
    }
    this._imageCache = {};
    this.cachedBackgroundSrc = null;
  },

  computed: {
    logoSrc() {
      if (this.defaultLogo) return this.$appLogo;
      else return this.$store.state.Store.store.info.logoUri;
    },

    sideBackgroundSrc() {
      let image = this.$store.getters.padMenuSchema.sideBackground?.image;
      if (image && (image.fileSize > 0 || image.altUrl)) return image.downloadPath;
      else return undefined;
    },

    news() {
      return this.$store.getters.padNews;
    },

    menu() {
      return this.$store.getters.padMenu;
    },

    classifies() {
      let _classifies = this.menu;
      return _classifies;
    },

    classify() {
      if (this.classifyName && this.classifies) return this.classifies.find(c => c.name == this.classifyName);
      else return undefined;
    },

    categories() {
      let n_categories = [];
      if (this.classify) {
        if (this.classify.categories) {
          let catIndex = 0;
          this.classify.categories.forEach(y => {
            y.index = catIndex;
            n_categories.push(y);
          });
        }
      }

      return n_categories;
    },

    categoryID() {
      if (this.category) {
        return this.category.ID;
      } else return 0;
    },

    categoryKey() {
      if (this.category) {
        return this.category.key;
      } else return undefined;
    },

    menuBackgroundImageSrc() {
      //console.log("classify", this.classify);

      let imageSrc;
      if (this.classify) {
        let image = this.classify.image;
        if (image && (image.fileSize > 0 || image.altUrl)) imageSrc = image.downloadPath;

        //console.log("imageSrc", imageSrc);
        //console.log("categoryID", this.categoryID);

        if (/*this.categoryID > 0 || this.categoryID > 0*/this.categoryKey) {
          //let category = this.categories.find(c => c.ID == this.categoryID);
          let category = this.categories.find(c => c.key == this.categoryKey);
          if (category) {
            image = category.menuSchema?.image;
            if (image && (image.fileSize > 0 || image.altUrl)) {
              let _imageSrc = image.downloadPath;
              if (_imageSrc) imageSrc = _imageSrc;
            }
          }
        }
      }

      return imageSrc;
    },

    menuMessage() {
      return this.$store.getters.padMenuMessage;
    },

    orderTotal() {
      return this.$store.state.Order.order.total;
    },

    timeRemain() {
      return this.$store.state.Pad.timeRemain;
    },
  },

  watch: {
    menuBackgroundImageSrc: {
      immediate: true,
      handler(newSrc) {
        this._cacheBackgroundImage(newSrc);
      },
    },

    timeRemain(newValue) {
      if (this.$router.currentRoute.name == "MenuFull") {
        if (this.$store.state.Pad.timeOutNotification === true) {
          if (newValue == 0 || this.$store.state.Pad.timeOutNotificationTime.find(x => x == newValue.toString())) {
            //(new Audio(bell)).play();
            if (this.notificationSound) this.notificationSound.stop();

            this.notificationSound = new Howl({
              src: [bell],
              autoplay: true,
              loop: newValue > 0 ? true : false,
            });
            this.notificationSound.play();

            this.$refs.timeUpDialog.open().then(() => {
              this.notificationSound.stop();
            });
          }
        }
      }
    },

    classify(n_classify) {
      let gridContainer = document.getElementById("grid-view-container");
      if (gridContainer) {
        gridContainer.removeEventListener("scroll", this.onGridViewScroll);
      }

      if (n_classify?.view == "grid") {
        let that = this;
        setTimeout(function() {
          let gridContainer = document.getElementById("grid-view-container");
          if (gridContainer) {
            gridContainer.addEventListener("scroll", that.onGridViewScroll);
          }
        }, 100);
      }

      let listContainer = document.getElementById("list-view-container");
      if (listContainer) {
        listContainer.removeEventListener("scroll", this.onListViewScroll);
      }

      if (n_classify?.view == "list") {
        let that = this;
        setTimeout(function() {
          let listContainer = document.getElementById("list-view-container");
          if (listContainer) {
            listContainer.addEventListener("scroll", that.onListViewScroll);
          }
        }, 100);
      }
    },

    /*
    category(newValue) {
      console.log("category", newValue);
      if (newValue?.menuSchema?.view == "image") setTimeout(() => this.mapResizer(), 1000);
    },
    */
  },

  methods: {
    /**
     * Fetches an image from the server, converts it to a blob URL,
     * and caches it so the browser doesn't re-request it from the server.
     */
    async _cacheBackgroundImage(src) {
      if (!src) {
        this.cachedBackgroundSrc = null;
        return;
      }

      // If already cached, use the cached blob URL immediately (no flicker)
      if (this._imageCache[src]) {
        this.cachedBackgroundSrc = this._imageCache[src];
        return;
      }

      // Set the original src immediately so the background is never blank
      // (critical for iPad PWA where fetch is slower)
      this.cachedBackgroundSrc = src;

      // Increment generation counter to discard stale preloads
      const gen = ++this._bgImageGen;

      try {
        const response = await fetch(src);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        this._imageCache[src] = blobUrl;

        // Preload in a hidden Image so it's fully decoded before swapping
        const img = new Image();
        img.onload = () => {
          // Only apply if this is still the latest request
          if (gen === this._bgImageGen) {
            this.cachedBackgroundSrc = blobUrl;
          }
        };
        img.src = blobUrl;
      } catch (err) {
        console.warn("Failed to cache background image:", err);
        // Keep the original URL that was already set above
      }
    },

    async startOver() {
      if (!await mApp.checkNetworkStatus()) return;  
      
      let inputRes = await this.$refs.inputDialog.open(this.$t("enter_your_password"));
      if (inputRes) {
        let resp_verify = await mApp.verifyAppPin({ appPin: inputRes });
        if (resp_verify?.result == "ok") {
          this.home();
        }
      }
      /*
      if (inputRes != null && inputRes == mUtils.decrypt("U2FsdGVkX1/h7sE+jqgAH8vVH9+R9T0HeYiVQ7kXDPM=")) {
        this.home();
      }
      */
    },

    home() {
      this.$store.dispatch("PAD_STOP_TIME_COUNTER");
      mApp.navName("Home", { authorized: true });
    },

    startMenu() {
      if (this.menu.length > 0) {
        let displayCat = this.menu[0];

        this.category = displayCat;
      }
    },

    itemBackgroundLoaded(cat) {
      console.log("itemBackgroundLoaded", cat);
      if (cat?.menuSchema?.view == "image") setTimeout(() => this.mapResizer(), 100);
    },

    mapResizer() {
      let maps = document.getElementsByTagName("map");
      //console.log("mapResizer/maps", maps);

      if (maps.length == 0) return;

      const map = maps[0];
      map.img = document.querySelectorAll(`[usemap="#${map.name}"]`)[0];
      const scale = map.img.offsetWidth / (map.img.naturalWidth || map.img.width);
      //console.log("mapResizer/scale", scale);

      for (const map of maps) {
        //console.log("mapResizer/maps/map", map);

        //map.img = document.querySelectorAll(`[usemap="#${map.name}"]`)[0];
        //console.log("mapResizer/maps/map.img", map.img);

        //const scale = map.img.offsetWidth / (map.img.naturalWidth || map.img.width);
        //console.log("mapResizer/maps/map/scale", scale);

        for (const area of map.areas) {
          area.coordArr = area.coords.split(",");
          area.coords = area.coordArr.map(coord => Math.round(coord * scale)).join(",");
        }
      }

      let badges = document.getElementsByClassName("badge-ordered-qty");
      //console.log(badges);
      for (const b of badges) {
        let top = parseInt(b.style.top, 10);
        let left = parseInt(b.style.left, 10);
        if (!isNaN(top)) b.style.top = top * scale + "px";
        if (!isNaN(left)) b.style.left = left * scale + "px";
        b.style["z-index"] = 2;
      }
    },

    onGridViewScroll() {
      if (this.viewScrollEventDisabled) return;

      let gridContainer = document.getElementById("grid-view-container");
      if (gridContainer) {
        for (let i = gridContainer.children.length - 1; i >= 0; i--) {
          if (gridContainer.scrollTop >= gridContainer.children[i].offsetTop) {
            let catKey = gridContainer.children[i].id;
            if (this.categories) {
              let _cat = this.categories.find(c => c.key == catKey);
              if (_cat) {
                this.category = _cat;
                break;
              }
            }
          }
        }
      }
    },

    onListViewScroll() {
      if (this.viewScrollEventDisabled) return;

      let listContainer = document.getElementById("list-view-container");
      if (listContainer) {
        for (let i = listContainer.children.length - 1; i >= 0; i--) {
          if (listContainer.scrollTop >= listContainer.children[i].offsetTop) {
            let catKey = listContainer.children[i].id;
            if (this.categories) {
              let _cat = this.categories.find(c => c.key == catKey);
              if (_cat) {
                this.category = _cat;
                break;
              }
            }
          }
        }
      }
    },

    catOrderQty(cat) {
      return this.$store.getters.orderCatQtyTotal(cat);
    },

    async classifyClicked(c) {
      let allow = true;
      if (c.authentication === true) {
        if (!await mApp.checkNetworkStatus()) return;

        allow = false;

        let inputRes = await this.$refs.inputDialog.open(this.$t("enter_your_password"));
        if (inputRes) {
          let resp_verify = await mApp.verifyAppPin({ appPin: inputRes });
          if (resp_verify?.result == "ok") {
            allow = true;
          }
        }
      }

      if (!allow) return;

      this.classifyName = c.name;
      if (this.categories.length > 0) {
        this.catClicked(this.categories[0]);
      } else this.cat = 0;
    },

    async catClicked(cat) {
      console.log('catClicked', cat);

      let orderCondition = cat?.menuSchema?.orderCondition;
      if (orderCondition) {
        let itemIds = orderCondition.condition?.itemId;
        if (itemIds && Array.isArray(itemIds) && itemIds.length > 0) {
          let orderItems = this.$store.state.Pad.order?.items;
          if (!orderItems || !orderItems.map(x => x.ID).some(y => itemIds.includes(y.toString()))) {
            this.$store.dispatch("PAD_GET_ORDER");

            //await wait(5000);

            let message = undefined;
            let messageText = orderCondition.message?.text;
            if (messageText) {
              message = messageText.def;
              if (this.$store.state.languageSelected) {
                let lang = this.$store.state.languageSelected;
                if (messageText[lang.locale]) {
                  message = messageText[lang.locale];
                }
              }
            }

            if (!message) message = this.$t("PAD.activate_category");
            mDialog.messageDialog.open(message);

            return;
          }
        }
      }

      this.category = cat;

      let that = this;
      if (cat.ID == -1 || cat.ID > 0) {
        setTimeout(function() {
          that.viewScrollEventDisabled = true;
          that.scrollToCat(cat);
        }, 1);

        setTimeout(function() {
          that.viewScrollEventDisabled = false;
        }, 100);
      }
    },

    scrollToCat(cat) {
      let element = document.getElementById(cat.key);
      if (element) {
        let gridViewContainer = document.getElementById("grid-view-container");
        if (gridViewContainer) {
          gridViewContainer.scrollTop = element.offsetTop;
        }

        let listViewContainer = document.getElementById("list-view-container");
        if (listViewContainer) {
          listViewContainer.scrollTop = element.offsetTop;
        }
      }
    },

    qtyBadgeStyle(item) {
      let itemStyle;
      if (item && item.menuSchema && item.menuSchema.quantityBadgeCoords) {
        let rect = mUtils.coordsToRect(item.menuSchema.quantityBadgeCoords);
        if (rect) {
          itemStyle = `top: ${rect.top}px; left: ${rect.left}px; z-index: -9999`;
        }
      }
      //console.log("itemStyle", item, itemStyle);

      return itemStyle;
    },

    itemClicked(payload) {
      //console.log("itemClicked", payload);

      let item = payload.item;
      let orderQty = payload.orderQty;
      if (!item) return;
      //if (item.orderDisabled === true) return;

      let soldout = this.$store.getters.itemSoldout(item);
      if (soldout) {
        mDialog.messageDialog.open(this.$store.getters.itemDescr(item), "", this.$t("MENU.out_of_stock"));
        return;
      }

      mAnalytics.logViewItem(item);

      if (item.itemDialog && orderQty >= 0) this.navOrderView(item);
      else this.updateOrderQty({ item: item, orderQty: orderQty });
    },

    async updateOrderQty(payload) {
      console.log("updateOrderQty", payload);

      let item = payload.item;
      let orderQty = payload.orderQty;
      if (orderQty === undefined) orderQty = 0;

      if (!item) return;

      /*
      if (orderQty > 0) {
        if (this.$store.getters.padSetting.checkItemInventory) {
          this.refreshing = true;
          await this.updateItemInventory(item);
          this.refreshing = false;

          let n_soldout = this.$store.getters.itemSoldout(item);
          if (n_soldout) return;
        }
      }
      */

      let orderItem = this.$store.state.Order.order.orderItems.find(x => x.ID == item.ID);
      if (orderItem) {
        if (orderQty > 0 || orderItem.qty + orderQty >= 0) {
          orderItem.qty += orderQty;
          orderItem.extended = this.$store.getters.orderItemExtended(orderItem);
        }
      } else if (orderQty > 0) {
        orderItem = this.itemToOrderItem(item);
        orderItem.qty = orderQty;
        mOrder.addOrderItem(orderItem);
      }
    },

    navOrderView(item) {
      this.$refs.orderDialog.open(item);
    },

    checkOutClicked() {
      this.$store.state.Order.order.orderItems = this.$store.state.Order.order.orderItems.filter(x => x.qty > 0);
      if (this.$store.state.Order.order.orderItems.length == 0) return;

      this.$refs.cartDialog.open();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/variables.scss";

$view-side-width: 270px;
$view-side-top-height: 215px;
$view-side-bottom-height: 420px;
$view-side-button-width: 270px;
$cat-item-height: 60px;
$item-ordered-qty-height: 40px;
$item-ordered-qty-adj-height: 36px;

::-webkit-scrollbar-thumb {
  //border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.1);
  //box-shadow: 0 0 1px rgba(214, 157, 157, 0.1);
}

.v-chip-group .v-slide-group__content {
  padding: 20px;
}

.v-slide-group__prev {
  min-width: 20px;
}

.v-slide-group__next {
  min-width: 20px;
}

.row {
  margin: 0px !important;
}

.col {
  padding-left: 0px !important;
}

.cart {
  //margin: 32px 0px 32px 64px;
  display: flex;
  //flex-grow: 0;
  align-items: center;
  justify-content: center;

  position: fixed;
  //bottom: calc(20px + env(safe-area-inset-bottom));
  //bottom: calc(20px + #{$bottom-toolbar-height});
  bottom: 30px;
  right: 30px;

  background-color: var(--v-primary-base);
  height: 64px;
  width: 64px;
  border-radius: 50%;

  .cart-badge {
    position: relative;
    .v-icon {
      font-size: 2em;
      color: var(--v-primaryText-base);
    }

    .cart-qty {
      display: flex;
      justify-content: center;
      align-items: center;

      position: absolute;
      top: -36px;
      left: 14px;

      height: 36px;
      width: 36px;

      font-size: 1em;
      text-align: center;

      background-color: var(--v-secondary-base);
      color: var(--v-secondaryText-base);
      border-radius: 25px;
      border: solid 2px var(--v-secondaryText-base);
    }
  }
}

.container {
  display: flex;
  padding: 0px;
  height: 100vh;

  .view-side {
    width: $view-side-width;

    //background-size: cover;

    //padding-right: 1px;

    display: flex;
    flex-direction: column;

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      //margin-bottom: -8px;
    }

    .view-side-top {
      position: absolute;
      left: 0px;
      top: 0px;
      height: $view-side-top-height;
      width: $view-side-width;

      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0px 0px;

      color: white;
      .v-icon {
        font-size: 1.2em;
        color: white;
        padding: 8px;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.25);
        align-self: flex-start;
        margin: 12px;
      }
    }

    .view-side-body {
      position: absolute;
      left: 0px;
      top: $view-side-top-height;
      width: $view-side-width;
      height: calc(100vh - #{$view-side-top-height} - 62px);

      overflow: auto;
      flex-grow: 1;

      .classify {
        color: var(--v-primary-base);
        background-color: var(--v-primaryText-base);
        padding: 4px 16px 4px 16px;
        border-radius: 10px 10px 0px 0px;

        font-size: 0.85em;
      }

      .classify-selected {
        @extend .classify;
        background-color: var(--v-primary-base);
        color: var(--v-primaryText-base);
      }
      .cat-list {
        background-color: transparent;
        overflow: auto;
        padding-top: 0px;
        .v-list-item {
          line-height: normal;
          //padding: 8px 8px;
          min-height: $cat-item-height;
          border-bottom: solid 1px grey;

          .cat-item-image {
            width: 40%;
            display: flex;
            justify-content: center;
            border-radius: 80px;
            object-fit: cover;
            width: 100%;
            height: 100%;
          }

          img {
            width: 80px;
            border-radius: 80px;
            object-fit: cover;
          }
          .cat-item-image {
            width: 40%;
            display: flex;
            justify-content: center;
            .v-carousel {
              width: 80px;

              img {
                border-radius: 80px;
                object-fit: cover;
                width: 100%;
                height: 100%;
              }
            }
          }

          .cat-item-body {
            //width: 60%;
            color: white;
            font-size: 1em;
            //font-weight: bold;

            .favorite-item {
              border-bottom: 4px solid var(--v-info-base);
            }

            .redeem-item {
              border-bottom: 4px solid var(--v-accent-base);
            }

            .ordered-qty {
              position: absolute;
              right: 0;
              top: 0;
              background-color: var(--v-primary-base);
              color: var(--v-primaryText-base);

              font-size: 0.85em;
              width: 30px;
              height: 30px;
              text-align: center;
              line-height: 30px;

              margin: 0px;
            }
          }
        }

        .v-list-item:first-child {
          border-top: solid 1px grey;
        }

        .cat-item-selected {
          background-color: var(--v-secondary-darken1);
          color: var(--v-secondaryText-base) !important;

          .cat-item-body {
            color: var(--v-secondaryText-base) !important;
          }
        }
      }
    }

    .view-side-bottom {
      height: $view-side-bottom-height;
      width: $view-side-width;
      background-color: white;
      border-right: solid 1px lightgrey;

      position: fixed;
      bottom: 0px;
      left: 0px;

      padding: 60px 0px;

      .v-btn {
        width: $view-side-button-width;
        border-radius: 10px;
      }

      .v-btn + .v-btn {
        margin-top: 24px;
      }
    }

    .powered-by {
      position: absolute;
      bottom: 12px;
      left: calc((270px - 180px) / 2);
    }
  }

  .view-body {
    width: calc(100% - #{$view-side-width});
    //display: flex;
    //flex-direction: column;

    .view-body-top {
      position: relative;
      font-size: 4em;
      font-weight: bold;
      line-height: 1.2em;
    }

    .view-body-body {
      //flex-grow: 1;
      //height: 0px;
      height: calc(100vh - 90px);
      //height: calc(100% - 90px);
      position: relative;

      .adv-view {
        position: relative;
        height: calc(100vh - 90px);
        //height: calc(100% - 90px);
        overflow: auto;
        overflow-x: hidden;

        img {
          object-fit: contain;
          width: 100%;
          margin-bottom: -8px;
        }
      }
      .image-view {
        position: relative;
        width: 100%;
        height: calc(100vh - 90px);
        overflow: hidden;

        img {
          object-fit: contain;
          margin-bottom: -8px;
        }
        .badge-ordered-qty {
          display: flex;
          justify-content: center;
          align-items: center;

          position: absolute;
          left: 0px;
          top: 0px;
          width: $item-ordered-qty-height;
          height: $item-ordered-qty-height;

          line-height: $item-ordered-qty-height;
          background-color: var(--v-secondary-base);
          color: var(--v-secondaryText-base);
          //text-align: center;
          //vertical-align: middle;
          font-size: 1.2em;
          border: solid 2px var(--v-secondaryText-base);
          border-radius: calc(#{$item-ordered-qty-height} / 2);

          .qty-adj-button {
            z-index: 2;
            display: flex;
            justify-content: center;
            align-items: center;

            position: absolute;
            top: calc((#{$item-ordered-qty-height} - #{$item-ordered-qty-adj-height}) / 2 - 2px);
            left: calc(#{$item-ordered-qty-height} + 10px);
            width: $item-ordered-qty-adj-height;
            height: $item-ordered-qty-adj-height;

            line-height: $item-ordered-qty-adj-height;
            background-color: var(--v-secondaryText-base);
            color: var(--v-secondary-base);
            text-align: center;
            vertical-align: middle;
            //font-size: 0.6em;
            border: solid 2px var(--v-secondary-base);
            border-radius: calc(#{$item-ordered-qty-adj-height} / 2);
          }
        }
      }

      .image-view.scroll-auto {
        overflow: auto;

        img {
          object-fit: unset;
        }
      }

      .image-view.scroll-auto-x {
        overflow: auto;
        overflow-y: hidden;

        img {
          height: inherit;
        }
      }

      .image-view.scroll-auto-y {
        overflow: auto;
        overflow-x: hidden;

        img {
          width: inherit;
        }
      }

      .list-view {
        //position: relative;
        //width: calc(100vw - 270px);
        height: calc(100vh - 90px);
        //height: calc(100% - 90px);

        .background-image {
          object-fit: cover;
          width: 100%;
          height: 100%;
          margin-bottom: -8px;
        }

        .list-view-container {
          height: calc(100vh - 90px - 90px);
          width: 100%;
          overflow: auto;
          position: absolute;
          top: 0px;

          .cat-container {
            position: unset !important;
            top: unset !important;
            height: unset !important;
            overflow: unset !important;
          }
        }
      }

      .grid-view {
        //position: relative;
        //width: calc(100vw - 270px);
        height: calc(100vh - 90px);
        //height: calc(100% - 90px);

        .background-image {
          object-fit: cover;
          width: 100%;
          height: 100%;
          margin-bottom: -8px;
        }

        .grid-view-container {
          height: calc(100vh - 90px - 90px);
          width: 100%;
          overflow: auto;
          position: absolute;
          top: 0px;

          .cat-container {
            position: unset !important;
            top: unset !important;
            height: unset !important;
            overflow: unset !important;
          }
        }
      }

      .view-body-body-bottom {
        position: absolute;
        bottom: 0px;
        height: 90px;
        max-height: 90px;
        //width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        //padding: 10px 10% 10px 10%;
        padding: 10px 100px 10px 20px;
        font-size: 0.7em;
        color: white;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }
}
</style>
